import { render, staticRenderFns } from "./so_to_invoice.vue?vue&type=template&id=dc8eb060&scoped=true"
import script from "./so_to_invoice.vue?vue&type=script&lang=js"
export * from "./so_to_invoice.vue?vue&type=script&lang=js"
import style0 from "./so_to_invoice.vue?vue&type=style&index=0&id=dc8eb060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8eb060",
  null
  
)

export default component.exports